import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { VueEditor } from 'vue2-editor'
import { mdiLeadPencil, mdiUpload } from '@mdi/js'

import BKUserSelect from '@/components/BKUserSelect.vue'
import BKOrganizationSelect from '@/components/BKOrganizationSelect.vue'
import GmapsPlaceInput from '@/components/GmapsPlaceInput.vue'
import EventEditActionButtons from '@/pages/CreateEventProcessingPage/ui/layout/EventEditActionButtons.vue'
import { eventApi, IEventStaffRole, IEventEdit } from '@/enitites/event'
import { UserDB } from '@/enitites/user'
import { useImage } from '@/shared/composables/image'
import BKEditorConfig from '@/common/vue2Config'

// @ts-expect-error Not a ts file
import store from '@/store'
import { useEventUpdateMutation } from '@/enitites/event/api/queries'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventInfo',
  props: {
    eventData: null
  },
  emits: ["next", "back", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'next'): void
  (e: 'back'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  eventData: IEventEdit
};

const { getImageById, saveImage } = useImage()
const { error, isPending, mutate: updateEvent } = useEventUpdateMutation()





const image = ref(props.eventData.image)
const orgId = ref(props.eventData.orgId)
const title = ref(props.eventData.title)
const location = ref({
  address: props.eventData.locationAddress,
  lat: props.eventData.locationLat,
  lng: props.eventData.locationLng,
})
const website = ref(props.eventData.website)
const description = ref(props.eventData.description)
const staff = ref(props.eventData.staff)

const errorMessage = ref<string>()
const isSavingImage = ref(false)
const imageError = ref<string>()
const optimisticImage = ref<string>()
const inputFileRef = ref<HTMLInputElement | null>(null)

const getUserDB = computed(() => store.getters.getUserDB)
const imageSrc = computed(() => {
  if (optimisticImage.value) {
    return optimisticImage.value
  }
  return image.value ? getImageById(image.value, 800, 800, 'event') : ''
})
const isInfoFilledOut = computed(() => !!title.value)
const adminIds = computed(() => staff.value.admins.map((user) => user.id))
const djIds = computed(() => staff.value.djs.map((user) => user.id))
const hostIds = computed(() => staff.value.hosts.map((user) => user.id))

function isValidUrl(str?: string): boolean {
  if (!str) return true
  try {
    const url = new URL(str)
    return url.protocol === 'https:'
  } catch {
    return false
  }
}

const validateUrlRule = (value: string) => isValidUrl(value) || 'URL should be in the format https://yourwebsite.com'

function openFileDialog(): void {
  inputFileRef.value?.click()
}

async function saveImageToEvent(imageFile: File): Promise<void> {
  isSavingImage.value = true
  imageError.value = undefined

  try {
    const result = await saveImage(imageFile)
    if (result) {
      image.value = result
    } else {
      optimisticImage.value = undefined
      imageError.value = 'Failed to upload image'
    }
  } catch (e) {
    optimisticImage.value = undefined
    imageError.value = (e as Error).message || 'Failed to upload image'
  } finally {
    isSavingImage.value = false
  }
}

function handleFileChange(evt: Event): void {
  const filesImg = (evt.target as HTMLInputElement).files
  if (!filesImg?.length) return

  saveImageToEvent(filesImg[0])
  const reader = new FileReader()
  reader.onload = (event) => {
    optimisticImage.value = event.target?.result as string
  }
  reader.readAsDataURL(filesImg[0])
}

async function addEventRole(user: UserDB, role: IEventStaffRole): Promise<void> {
  try {
    const resp = await eventApi.addRole(props.eventData.id, user.id, role)
    if (resp) staff.value = resp
  } catch (e) {
    errorMessage.value = (e as Error).message || 'Failed to add role'
  }
}

async function removeEventRole(user: UserDB, role: IEventStaffRole): Promise<void> {
  try {
    const resp = await eventApi.removeRole(props.eventData.id, user.id, role)
    if (resp) staff.value = resp
  } catch (e) {
    errorMessage.value = (e as Error).message || 'Failed to remove role'
  }
}

function saveEventData(onSuccess: () => void) {
  if (!isInfoFilledOut.value || isPending.value) return
  errorMessage.value = undefined

  const payload = {
    ...props.eventData,
    id: props.eventData.id,
    image: image.value,
    orgId: orgId.value,
    title: title.value,
    locationAddress: location.value.address,
    locationLat: location.value.lat,
    locationLng: location.value.lng,
    website: website.value,
    description: description.value,
    staff: staff.value,
  }

  updateEvent(payload, { onSuccess })
}

async function handleNext() {
  saveEventData(() => {
    emit('next')
  })
}

function handleCancel() {
  saveEventData(() => {
    emit('cancel')
  })
}

return { __sfc: true,getImageById, saveImage, error, isPending, updateEvent, props, emit, image, orgId, title, location, website, description, staff, errorMessage, isSavingImage, imageError, optimisticImage, inputFileRef, getUserDB, imageSrc, isInfoFilledOut, adminIds, djIds, hostIds, isValidUrl, validateUrlRule, openFileDialog, saveImageToEvent, handleFileChange, addEventRole, removeEventRole, saveEventData, handleNext, handleCancel, VueEditor, mdiLeadPencil, mdiUpload, BKUserSelect, BKOrganizationSelect, GmapsPlaceInput, EventEditActionButtons, BKEditorConfig }
}

})